import { async, types } from '~/utils/typeCreator'

export default types(
  [...async('SEARCH_REPORTS'), ...async('STATS'), 'CLEAR_STATE'],
  'NOTICE_MANAGEMENT_REPORTS'
)
